import React from 'react';
import PropTypes from 'prop-types';

class BaseInputValidationComponent extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            errorMessages: [],
            isValid: false
        };
    }

    getErrorMessage() {
        return this.state.errorMessages.length > 0 && this.state.errorMessages[0];
    }

    notifyOfValidation(name, isValid, errs) {
        if (this.props.onValidate) {
            this.props.onValidate(isValid, errs);
        }

        if (this.props.updateFormOnValidation) {
            this.props.updateFormOnValidation(name, isValid, errs);
        }
    }
}

BaseInputValidationComponent.propTypes = {
    name: PropTypes.string,
    onValidate: PropTypes.func,
    onFormUpdate: PropTypes.func
};

export default BaseInputValidationComponent;

